export default "__VITE_ASSET__7B8fik_H__"